import React from 'react'
import { format, addDays } from 'date-fns'

export default function LineItemNotifications({ isShippable, restockDate, isFlyoutCart }) {
  if (isShippable || !restockDate) {
    return null
  }

  const notifications = (() => {
    if (isFlyoutCart) {
      return [<li>This item ships on {format(addDays(new Date(restockDate), 7), 'MMMM d')}</li>]
    } else {
      return [
        <li>
          This size ships on{' '}
          <span className="product-notifications__message--backorder-date">
            {format(addDays(new Date(restockDate), 7), 'MMMM d')}
          </span>
        </li>,
      ]
    }
  })()

  if (isFlyoutCart) {
    return (
      <div className="product-notifications-container--flyout-cart">
        {notifications && notifications.length > 0 && <ul>{notifications}</ul>}
      </div>
    )
  } else {
    return (
      <div className="product-notifications-container">
        {notifications && notifications.length > 0 && (
          <ul className="product-notifications">{notifications}</ul>
        )}
      </div>
    )
  }
}

LineItemNotifications.displayName = 'LineItemNotifications'
